var render = function render(_c,_vm){return _c('div',{ref:_vm.data.ref,staticClass:"rainbow-gradient",class:[_vm.data.class, _vm.data.staticClass, { 'is-static': _vm.props.static }],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"rainbow-gradient__image"}),_vm._v(" "),(!_vm.props.static)?_c('div',{staticClass:"rainbow-gradient__image"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }